import html2canvas from "html2canvas";

// Returns a blob — caller handles the upload
export async function captureAndUpload(compositorElement, constellationId, style, supabase) {
  var blob = null;

  // ── APPROACH 1: Native SVG to Canvas ──
  try {
    console.log("Capture: trying native SVG...");
    var svgEl = compositorElement.querySelector("svg");
    if (!svgEl) throw new Error("No SVG found");

    var clone = svgEl.cloneNode(true);
    clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    clone.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");

    // Remove <style> and <filter> — they break XML serialization
    clone.querySelectorAll("style").forEach(function(s) { s.remove(); });
    clone.querySelectorAll("filter").forEach(function(f) { f.remove(); });

    var viewBox = clone.getAttribute("viewBox") || "0 0 100 125";
    var parts = viewBox.split(/[\s,]+/);
    var svgW = parseFloat(parts[2]) || 100;
    var svgH = parseFloat(parts[3]) || 125;
    var scale = 3600 / Math.max(svgW, svgH);
    var canvasW = Math.round(svgW * scale);
    var canvasH = Math.round(svgH * scale);

    clone.setAttribute("width", String(canvasW));
    clone.setAttribute("height", String(canvasH));
    clone.removeAttribute("style");

    var svgString = new XMLSerializer().serializeToString(clone);
    var encoded = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgString);

    blob = await new Promise(function(resolve, reject) {
      var img = new Image();
      var timeout = setTimeout(function() { reject(new Error("timeout")); }, 8000);
      img.onload = function() {
        clearTimeout(timeout);
        console.log("Capture: SVG loaded, drawing", canvasW, "x", canvasH);
        var canvas = document.createElement("canvas");
        canvas.width = canvasW;
        canvas.height = canvasH;
        var ctx = canvas.getContext("2d");
        ctx.fillStyle = "#0E0B18";
        ctx.fillRect(0, 0, canvasW, canvasH);
        ctx.drawImage(img, 0, 0, canvasW, canvasH);
        canvas.toBlob(function(b) {
          if (b && b.size > 5000) { console.log("Capture: SVG success:", b.size); resolve(b); }
          else { reject(new Error("blob too small")); }
        }, "image/png", 1.0);
      };
      img.onerror = function() { clearTimeout(timeout); reject(new Error("img error")); };
      img.src = encoded;
    });
  } catch (e) {
    console.warn("Capture: native SVG failed:", e.message);
    blob = null;
  }

  // ── APPROACH 2: html2canvas ──
  if (!blob) {
    try {
      console.log("Capture: trying html2canvas...");
      var canvas = await html2canvas(compositorElement, {
        scale: 3,
        backgroundColor: "#0E0B18",
        useCORS: true,
        allowTaint: true,
        logging: true,
      });
      console.log("Capture: html2canvas canvas:", canvas.width, "x", canvas.height);
      blob = await new Promise(function(resolve, reject) {
        canvas.toBlob(function(b) {
          if (b && b.size > 5000) { console.log("Capture: html2canvas success:", b.size); resolve(b); }
          else { reject(new Error("html2canvas blob small")); }
        }, "image/png", 1.0);
      });
    } catch (e) {
      console.error("Capture: html2canvas failed:", e.message);
      throw new Error("Could not capture poster. Try Chrome or refresh.");
    }
  }

  if (!blob) throw new Error("No image captured");

  // ── UPLOAD to Supabase storage ──
  var fileName = constellationId + "_" + style + "_" + Date.now() + ".png";
  console.log("Capture: uploading", fileName, "size:", blob.size);
  var result = await supabase.storage.from("designs").upload(fileName, blob, {
    contentType: "image/png",
    upsert: true,
  });
  if (result.error) throw new Error("Upload failed: " + result.error.message);
  var urlData = supabase.storage.from("designs").getPublicUrl(fileName);
  console.log("Capture: done!", urlData.data.publicUrl);
  return urlData.data.publicUrl;
}
